import React, { useEffect, useMemo, useState } from "react";
import { AdminPager } from "@/components/admin/AdminPager";

export const ADMIN_PAGE_SIZE = 25;

const keyOf = (x) => x?.id ?? x?.uid ?? x?.path ?? x?.guid ?? x?.key ?? "";

// Pagination côté client d'une liste déjà chargée : 25 lignes par page, retour à la page 1 quand la liste
// change (filtre, recherche, rechargement) et page ramenée dans les bornes quand des lignes disparaissent.
export const usePager = (items, pageSize = ADMIN_PAGE_SIZE) => {
  const [page, setPage] = useState(1);
  const list = useMemo(() => items || [], [items]);
  const total = list.length;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const resetKey = `${total}:${keyOf(list[0])}:${keyOf(list[total - 1])}`;
  useEffect(() => { setPage(1); }, [resetKey]);
  const safePage = Math.min(page, pages);
  const slice = useMemo(() => list.slice((safePage - 1) * pageSize, safePage * pageSize), [list, safePage, pageSize]);
  return { page: safePage, setPage, pages, total, slice, pageSize };
};

// Ligne « 1–25 sur 212 · page 1/9 » + pages numérotées. `noun` : « vidéo », « ticket »… (pluriel en +s).
export const PagerBar = ({ page, pages, total, pageSize = ADMIN_PAGE_SIZE, shown, onPage, noun = "ligne", testId = "pager", className = "" }) => {
  if (!total || pages <= 1) return null;
  const count = shown ?? Math.min(pageSize, total - (page - 1) * pageSize);
  const first = (page - 1) * pageSize + 1;
  const last = first + count - 1;
  return (
    <div className={`flex flex-wrap items-center justify-between gap-2 pt-3 ${className}`} data-testid={`${testId}-bar`}>
      <div className="text-xs" style={{ color: "var(--yalola-text-muted)" }} data-testid={`${testId}-count`}>
        {first}–{last} sur <b>{total.toLocaleString("fr-FR")}</b> {noun}{total > 1 ? "s" : ""} · page {page}/{pages}
      </div>
      <AdminPager page={page} pages={pages} onPage={onPage} testId={testId} />
    </div>
  );
};
